import { RemoveCredentialModal } from 'core/Components';

import {
  ModalTitleWithBackButton,
  useCredentialCardModalProvider,
} from './CredentialCardModalFactory';

const RemoveCredentialModalWrapper = ({ credentialId }: { credentialId: string }) => {
  const { opened, close, openBack } = useCredentialCardModalProvider({
    id: 'Remove',
  });

  return (
    <RemoveCredentialModal
      opened={opened}
      onClose={close}
      onBack={openBack}
      credentialId={credentialId}
      header={<ModalTitleWithBackButton>Remove Card</ModalTitleWithBackButton>}
    />
  );
};

export { RemoveCredentialModalWrapper };
